import React from 'react'

import Card from '../../common/Card/Card.tsx'
import QRCodePDF from '../qrCodes/QRCodePDF.tsx'


const PopupQRCode = ({ codeAssignment }: { codeAssignment: string }) => {
  return (
    <div>
      <div className="mx-auto max-w-150">
        <Card>
          <Card.Title>
              {'Twój kod identyfikujący'}
          </Card.Title>
          <Card.Body>
            <div className="flex flex-1 justify-center">


            <h2 className="mb-2 text-xl font-bold text-black dark:text-white sm:text-title-md">
              {codeAssignment}
            </h2>
              </div>
            <div className="flex flex-col gap-2 mb-5">
              <QRCodePDF assignmentCode={codeAssignment} />
            </div>
          </Card.Body>
        </Card>
      </div>
    </div>
  )
}

export default PopupQRCode
